import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Anchor } from '@sitebase/ui-kit/es/buttons';

import { getAllowedAttributes } from '../../props-filters';

import './ProductSpecificNav.scss';

var ProductSpecificNavItem = function ProductSpecificNavItem(_ref) {
  var children = _ref.children,
      active = _ref.active,
      onClick = _ref.onClick,
      href = _ref.href,
      target = _ref.target,
      rel = _ref.rel,
      restProps = _objectWithoutProperties(_ref, ['children', 'active', 'onClick', 'href', 'target', 'rel']);

  return React.createElement(
    'div',
    _extends({
      className: cx({
        'sb-header-product-specific-nav__item': true,
        'sb-header-product-specific-nav__item--active': active
      })
    }, getAllowedAttributes(restProps)),
    href ? React.createElement(
      Anchor,
      { outfit: 'white normal', onClick: onClick, target: target, href: href, rel: rel },
      children
    ) : React.createElement(
      'span',
      { onClick: onClick },
      children
    )
  );
};

ProductSpecificNavItem.propTypes = {
  children: PropTypes.node,
  active: PropTypes.bool,
  onClick: PropTypes.func,
  href: PropTypes.string,
  target: PropTypes.string,
  rel: PropTypes.string
};

export default ProductSpecificNavItem;
//# sourceMappingURL=ProductSpecificNavItem.js.map